import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../siteConfig";
import { primaryPolicies } from "../policies";
import "../css/privacy.scss";

const slug = (value) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

function PolicyPage({ policy }) {
  return (
    <main className="policy-page page-shell">
      <header className="policy-header">
        <p className="eyebrow">{policy.category}</p>
        <h1>{policy.title}</h1>
        <p className="policy-summary">{policy.summary}</p>
      </header>
      <div className="policy-layout">
        <aside>
          <p>Updated {policy.updated}</p>
          <nav aria-label={`${policy.title} contents`}>
            {policy.sections.map((section) => (
              <a key={section.heading} href={`#${slug(section.heading)}`}>
                {section.heading}
              </a>
            ))}
          </nav>
        </aside>
        <article>
          {policy.sections.map((section) => (
            <section id={slug(section.heading)} key={section.heading}>
              <h2>{section.heading}</h2>
              {section.body?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {section.bullets && (
                <ul>{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul>
              )}
            </section>
          ))}
          <section className="policy-contact" id="contact">
            <h2>Questions or requests</h2>
            <p>
              Contact <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> and include the policy title, page URL and any order reference. Do not send card details. This policy does not limit consumer or data rights that cannot lawfully be excluded.
            </p>
          </section>
          <nav className="policy-quick-links" aria-label="Core policies">
            {primaryPolicies.filter((item) => item.path !== policy.path).map((item) => (
              <Link key={item.path} to={item.path}>{item.shortTitle}</Link>
            ))}
          </nav>
        </article>
      </div>
    </main>
  );
}

export default PolicyPage;
